import React from "react";
import {FormattedMessage} from "react-intl";
import RadioButtonGroup from "../../RadioButtonGroup/RadioButtonGroup";
import {Link} from "react-router-dom";

let goldFinger = [
    {
        id: 0,
        checked: false,
        name: "goldFinger",
        text: <FormattedMessage id="app.pcb-quotation.pcb-gold-fingers-no"
                                defaultMessage="No" description=""/>
    },
    {
        id: 2,
        checked: true,
        name: "goldFinger",
        text: <FormattedMessage id="app.pcb-quotation.pcb-gold-fingers-yes"
                                defaultMessage="Yes (45 chamfered border)" description=""/>
    },
];

const PCBGoldFingers = (props) => {

    let PCBGoldFingers = goldFinger.map((item) => {
        item.checked = (item.id === props.selectedId);
        return item;
    });

    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-gold-fingers"
                                          defaultMessage="PCB Gold Fingers"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <Link id="pcbGld-qLink"
                            to={{pathname:"https://kitcutlabo.com/goldfingers/"}} target="_self"
                            className="glyphicon glyphicon-question-sign question-link"></Link>
                    </div>
                    <div className="btn-group col-md-9 pcb-details-div-items">
                        <RadioButtonGroup data={PCBGoldFingers} getParams={props.setPCBParams}/>

                        <p className="pcb-details-div-clr-caption ">
                            {/*&#x1360;*/}
                            {/*<FormattedMessage id="app.pcb-quotation.gold-finger-caption"*/}
                                                       {/*defaultMessage="ゴールドフィンガー（45°面取り）オプションは、表面仕上げRoHs（金メッキ）のみ適用可能です"*/}
                                                       {/*description=""/>*/}


                            ፠ 端子仕上げ：面取りあり（４５°）オプション、表面処理仕上げにて“無電解金フラッシュ
                        </p >
                        <p className="pcb-details-div-clr-caption ">
                            （RoHs対応）”のみ適用可能です。
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PCBGoldFingers;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/PCBGoldFingers.js